<template>
  <div class="my-course-warp">
    <NavHeaderBar title="我的课程" leftArrow rightArrow />
    <div v-if="!show" class="my-course-warp-linecontentitem">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了~"
        @load="onLoad"
      >
        <LineContentItem
          v-for="(item, index) in coureList"
          :key="item.zbcode + index"
          :zbcode="item.zbcode"
          :onecode="item.onecode"
          :name="item.zbname"
          :date="item.begintime"
          :zbflag="item.zbzbflag"
          :cover="item.cover"
          :isMy="true"
        >
          <div class="my-course-warp-time">
            <span class="my-course-warp-time-contentone"
              >视频时长: {{ item.playtimelimit }}</span
            >
          </div>
          <div class="my-course-warp-fenshu">
            <span class="my-course-warp-fenshu-content"
              >关注: {{ item.clickon | filterBigNumbers }}</span
            >
            <span class="my-course-warp-fenshu-contentone">
              类别：{{ item.columnname }}
            </span>
          </div>
        </LineContentItem>
      </van-list>
    </div>
    <div v-else>
      <Default :imgurl="require('@/assets/img/df-5.png')" text="暂无课程" />
    </div>
  </div>
</template>

<script>
import apis from "@/config/apis";
export default {
  name: "MyCoures",
  data() {
    return {
      params: {
        size: 10,
        page: 1
      },
      coureList: [],
      num: 0,
      loading: false,
      finished: false,
      show: false
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.getLive();
    },
    async getLive() {
      try {
        const resp = await apis.user.getMyCourse(this.params);
        if (resp.success === "ok") {
          if (resp.total === 0) {
            this.show = true;
          } else {
            this.show = false;
            this.params.page++;
            this.coureList = [...this.coureList, ...resp.courselist];
            this.num = resp.total;
            this.loading = false;
            if (this.coureList.length >= resp.total) {
              this.finished = true;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss">
.my-course-warp {
  .my-course-warp-linecontentitem {
    margin-top: 50px;
    padding: 0px 12px;
    .my-course-warp-time {
      display: flex;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      color: #999999;
      padding-top: 3px;
      .my-course-warp-time-content {
        flex: 2;
      }
      .my-course-warp-time-contentone {
        flex: 3;
      }
    }
    .my-course-warp-fenshu {
      display: flex;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      color: #999999;
      padding-top: 3px;
      .my-course-warp-fenshu-content {
        flex: 4;
      }
      .my-course-warp-fenshu-contentone {
        flex: 6;
      }
    }
  }
}
</style>
